export default {
  title: {
    en: 'Are you sure you want to cancel?',
  },
  text: {
    en: `
      If you cancel your subscription, you won’t be able to undo this action and any free months on your account will be lost. 
      You may be put on a waiting list if you choose to re-subscribe in the future.
    `,
  },
  neverMindButton: {
    en: 'Never mind',
  },
}
